// extracted by mini-css-extract-plugin
export var header = "_t8-1";
export var maskBottom = "_t8-6";
export var maskMiddle = "_t8-7";
export var maskTop = "_t8-5";
export var root = "_t8-0";
export var scrollDownButton = "_t8-3";
export var scrollDownButtonHidden = "_t8-4";
export var viewport = "_t8-2";